import React, { useState } from "react";
import { Box, Typography, Grid, TextField, Button } from "@mui/material";
// import { useFormik } from 'formik';
// import * as yup from 'yup';
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
// import '../../../css/style.css'
import { Formik } from "formik";
import { createOffer } from "../shared/validation/validation";
import { createOfferServ,updateOfferService } from "../services/offerService";
import { useNavigate,useLocation } from "react-router-dom";
import Loader from "../shared/components/Loader";
import { toastMessage } from "../shared/components/Toast";
import { useEffect } from "react";
function CreateOffer() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const locationOfferDetail = location?.state?.offer
  
  const [initialValues,setInialValues] =  useState({
    title:  "",
    url:  "",
    type:  "",
    dis: "",
    oferImage: "",
    offerImageMobile:"",
    terms:  "",
  });
  const handleCreateOffer = (obj) => {
    setLoading(true);
    createOfferServ(obj)
      .then(({ data }) => {
        toastMessage("Offer created Successfully!","success")
        navigate("/offer");
      })
      .catch((err) => {
        toastMessage(err?.response?.data?.message, 'error')
      })
      .finally(() => setLoading(false));
  };
  const handleUpdateOffer = (obj) => {
    setLoading(true);
    updateOfferService(locationOfferDetail?._id,obj)
      .then(({ data }) => {
        toastMessage("Offer Updated Successfully!","success")
        navigate("/offer");
      })
      .catch((err) => {
        toastMessage(err?.response?.data?.message, 'error')
      })
      .finally(() => setLoading(false));
  };
  const numbers = Array.from({ length: 100 }, (_, i) => i + 1);
  useEffect(()=>{
    setInialValues({
      ...initialValues,
      title:locationOfferDetail?.title ? locationOfferDetail?.title:"" ,
      url:locationOfferDetail?.ctaValue ? locationOfferDetail?.ctaValue:"",
      type:locationOfferDetail?.ctaKind ? locationOfferDetail?.ctaKind:"" ,
      dis:locationOfferDetail?.discountPercentage ? locationOfferDetail?.discountPercentage:"" ,
      oferImage:locationOfferDetail?.imageURL ? locationOfferDetail?.imageURL:"" ,
      offerImageMobile:locationOfferDetail?.imageURL_mobile ? locationOfferDetail?.imageURL_mobile:"" ,
      terms:locationOfferDetail?.description ? locationOfferDetail?.description:"" 
    })
    // initialValues.title = locationOfferDetail?.title ? locationOfferDetail?.title:"" 
    // initialValues.url = locationOfferDetail?.ctaValue ? locationOfferDetail?.ctaValue:"" 
    // initialValues.type = locationOfferDetail?.ctaKind ? locationOfferDetail?.ctaKind:"" 
    // initialValues.dis = locationOfferDetail?.discountPercentage ? locationOfferDetail?.discountPercentage:"" 
    // initialValues.oferImage = locationOfferDetail?.imageURL ? locationOfferDetail?.imageURL:"" 
    // initialValues.offerImageMobile = locationOfferDetail?.imageURL_mobile ? locationOfferDetail?.imageURL_mobile:"" 
    // initialValues.terms = locationOfferDetail?.description ? locationOfferDetail?.description:"" 
  },[locationOfferDetail]);
  return (
    <>
      <Box className="">
        <Box
          borderBottom={"1px solid #B9C5D275"}
          flexDirection={"column"}
          display={"flex"}
        >
          <Typography
            variant="h5 "
            fontFamily={"inter"}
            fontSize={"20px"}
            fontWeight={600}
            sx={{ mb: 1, mt: 3, ml: 3, color: "#2F496C" }}
          >
            Create Offer
          </Typography>

          <Typography
            variant="body6"
            fontFamily={"inter"}
            fontSize={"12px"}
            fontWeight={400}
            sx={{ mb: 2.5, ml: 3, color: "#899CAF" }}
          >
            Fill form to create an Offer to share with you audience.
          </Typography>
        </Box>
        <Formik
        enableReinitialize
          initialValues={initialValues}
          onSubmit={(values, action) => {
            action.setSubmitting(true);
            // handleLogIn(values, action);
            let obj = {
                title: values?.title,
                imageURL: values?.oferImage,
                imageURL_mobile:values?.offerImageMobile,
                ctaKind: values?.type,
                ctaValue: values?.url,
                description: values?.terms,
                discountPercentage: values?.dis
              }
              if(location?.state?.isEdit){
                handleUpdateOffer(obj)
              }else{

                handleCreateOffer(obj);
              }
          }}
          validationSchema={createOffer}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
          }) => (
            <>
              <Box display={"flex"} justifyContent={"center"}>
                <Box sx={{ mt: 5, pb: 5 }} border={"1px solid #B9C5D275"}>
                  <Box bgcolor={"#F8F8F8"} sx={{ py: 2 }}>
                    <Typography variant="body5" sx={{ ml: 2 }}>
                      Offer Details
                    </Typography>
                  </Box>
                  {/*-------------------- input ----------------------*/}
                  <Box sx={{ px: 3 }}>
                    <Grid container spacing={1}>
                      <Grid xs={6}>
                        <Box sx={{ mt: 2 }}>
                          <Typography
                            variant="body5"
                            fontFamily={"inter"}
                            fontSize={"12px"}
                            fontWeight={500}
                            color={"#899CAF"}
                            sx={{ ml: 0.7 }}
                            id="starick"
                          >
                            Offer Title
                          </Typography>
                        </Box>
                        <Box
                          component="form"
                          sx={{
                            "& > :not(style)": { mt: 1.5 },
                            "& .MuiInputBase-root": {
                              height: 50,
                            },
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          <TextField
                            name="offer_tital"
                            sx={{
                              "& > :not(style)": { width: "100%" },
                            }}
                            placeholder="Enter Title"
                            value={values.title}
                            onChange={handleChange("title")}
                            error={touched.title && Boolean(errors.title)}
                            helperText={touched.title && errors.title}
                          />
                        </Box>
                      </Grid>
                      <Grid xs={6}>
                        <Box sx={{ mt: 2 }}>
                          <Typography
                            variant="body5"
                            fontFamily={"inter"}
                            fontSize={"12px"}
                            fontWeight={500}
                            color={"#899CAF"}
                            sx={{ ml: 0.7 }}
                            id="starick"
                          >
                            Action URL
                          </Typography>
                        </Box>
                        <Box
                          component="form"
                          sx={{
                            "& > :not(style)": { mt: 1.5 },
                            "& .MuiInputBase-root": {
                              height: 50,
                            },
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          <TextField
                            name="offer_tital"
                            sx={{
                              "& > :not(style)": { width: "100%" },
                            }}
                            placeholder="Action URL"
                            value={values.url}
                            onChange={handleChange("url")}
                            error={touched.url && Boolean(errors.url)}
                            helperText={touched.url && errors.url}
                          />
                        </Box>
                      </Grid>
                      <Grid xs={6}>
                        <Box sx={{ mt: 2 }}>
                          <Typography
                            variant="body5"
                            fontFamily={"inter"}
                            fontSize={"12px"}
                            fontWeight={500}
                            color={"#899CAF"}
                            sx={{ ml: 0.7 }}
                            id="starick"
                          >
                            Click Type
                          </Typography>
                        </Box>
                        <Box
                          component="form"
                          sx={{
                            "& > :not(style)": { mt: 1.5 },
                            "& .MuiInputBase-root": {
                              height: 50,
                            },
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          <FormControl style={{ width: "100%" }}>
                            <InputLabel id="demo-simple-select-label">
                              Select click action
                            </InputLabel>
                            <Select
                              className="myclick_dropdown fromcontrol_dropdown"
                              label="Select click action"
                              name="click_type"
                              value={values.type}
                              onChange={handleChange("type")}
                              
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              {" "}
                              <MenuItem value={""} disabled>
                                --Choose and option--
                              </MenuItem>
                              <MenuItem value={"URL"}>Open URL</MenuItem>
                              <MenuItem value={"APPOINTMENT"}>
                                Book Appointment
                              </MenuItem>
                            </Select>
                            {touched.type && errors.type ? (
                              <span className="error">{errors.type}</span>
                            ) : (
                              ""
                            )}
                          </FormControl>
                        </Box>
                      </Grid>
                      <Grid xs={6}>
                        <Box sx={{ mt: 2 }}>
                          <Typography
                            variant="body5"
                            fontFamily={"inter"}
                            fontSize={"12px"}
                            fontWeight={500}
                            color={"#899CAF"}
                            sx={{ ml: 0.7 }}
                            id="starick"
                          >
                            Discount Percentage
                          </Typography>
                        </Box>
                        <Box
                          component="form"
                          sx={{
                            "& > :not(style)": { mt: 1.5 },
                            "& .MuiInputBase-root": {
                              height: 50,
                            },
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          <FormControl style={{ width: "95%" }}>
                            <InputLabel id="demo-simple-select-label">
                              Select Discount
                            </InputLabel>
                            <Select
                              name="discount_persontage "
                              label="Select click action"
                              className="fromcontrol_dropdown"
                              value={values.dis}
                              onChange={handleChange("dis")}
                            >
                              {numbers.map((number, inx) => (
                                <MenuItem key={inx} value={number}>
                                  {number}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {touched.dis && errors.dis ? (
                            <span className="error">{errors.dis}</span>
                          ) : (
                            ""
                          )}
                        </Box>
                      </Grid>
                      <Grid xs={12}>
                        <Typography
                          variant="body5"
                          fontFamily={"inter"}
                          fontSize={"12px"}
                          fontWeight={500}
                          color={"#899CAF"}
                          sx={{ ml: 0.7 }}
                          id="starick"
                        >
                          Offer Image
                        </Typography>
                        <TextField
                          style={{ width: "100%" }}
                          // label="Image*"
                          placeholder="Enter Offer Image URL"
                          value={values.oferImage}
                          onChange={handleChange("oferImage")}
                          error={touched.oferImage && Boolean(errors.oferImage)}
                          helperText={touched.oferImage && errors.oferImage}
                          sx={{
                            "& > :not(style)": { mt: 0 },
                            "& .MuiInputBase-root": {
                              width: "100% !important",
                            },
                          }}
                        />
                      </Grid>
                      <Grid xs={12}>
                        <Typography
                          variant="body5"
                          fontFamily={"inter"}
                          fontSize={"12px"}
                          fontWeight={500}
                          color={"#899CAF"}
                          sx={{ ml: 0.7 }}
                          id="starick"
                        >
                          Offer Image Mobile
                        </Typography>
                        <TextField
                          style={{ width: "100%" }}
                          // label="Image*"
                          placeholder="Enter Offer Image URL Mobile"
                          value={values.offerImageMobile}
                          onChange={handleChange("offerImageMobile")}
                          error={touched.offerImageMobile && Boolean(errors.offerImageMobile)}
                          helperText={touched.offerImageMobile && errors.offerImageMobile}
                          sx={{
                            "& > :not(style)": { mt: 0 },
                            "& .MuiInputBase-root": {
                              width: "100% !important",
                            },
                          }}
                        />
                      </Grid>
                      <Grid xs={12}>
                        <TextField
                          style={{ width: "100%" }}
                          placeholder="Define your offer by entering terms & conditions*"
                          name="creatoffer_discripton"
                          value={values.terms}
                          onChange={handleChange("terms")}
                          error={touched.terms && Boolean(errors.terms)}
                          helperText={touched.terms && errors.terms}
                          sx={{
                            "& > :not(style)": { mt: 1 },
                            "& .MuiInputBase-root": {
                              width: "100% !important",
                            },
                          }}
                          multiline
                          rows={6}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Box>
              <Box
                display={"flex"}
                justifyContent={"end"}
                sx={{ mr: 4.5, mt: 4, pb: 5 }}
              >
                <Box>
                  <Button
                      onClick={()=>navigate(-1)}
                    sx={{
                      color: "#8B8D90",
                      bgcolor: "#EEEEEE",
                      px: 6,
                      py: 1.5,
                      mr: 2.5,
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
                <Box>
                  <Button
                    disabled={loading}
                    sx={{
                      color: "#2E7FFD",
                      bgcolor: "#2E7FFD1F",
                      px: 6,
                      py: 1.5,
                    }}
                    onClick={handleSubmit}
                  >
                    {loading ? <Loader colors={"#2278CF"} /> : location?.state?.isEdit ? "Update": "Create"}
                  </Button>
                </Box>
              </Box>
            </>
          )}
        </Formik>
      </Box>
    </>
  );
}

export default CreateOffer;
